/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AddImportFilePayload,
  CategoryDetailedGet,
  CategoryFilter,
  CategoryGet,
  CloneProductBody,
  CloneProductParams,
  CreateCategoryBody,
  CreateCategoryParams,
  DeleteSecurityRuleBody,
  ExportCategoryBody,
  ImportCheckPayload,
  ImportEmbPayload,
  ImportEmbxPayload,
  SecurityFilter,
  SetDefaultCategoryBody,
  TableModel1CategorySecurityGet,
  UpdateCategoryBody,
  UpdateSecurityRuleBody,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Categories<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Categories
   * @name GetCategoriesTree
   * @summary Возвращает категории, удовлетворяющие критериям фильтрации в виде удобном для отображения в виде дерева.
   * @request POST:/categories/getCategoriesTree
   * @secure
   * @response `200` `(CategoryGet)[]` Дерево категорий
   */
  getCategoriesTree = (data: CategoryFilter, params: RequestParams = {}) =>
    this.request<CategoryGet[], any>({
      path: `/categories/getCategoriesTree`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Categories
   * @name CategoriesDetail
   * @summary Получить детали категории по идентификатору
   * @request GET:/categories/{categoryId}
   * @secure
   * @response `200` `CategoryDetailedGet` Подробная информация о категории
   */
  categoriesDetail = (categoryId: string, params: RequestParams = {}) =>
    this.request<CategoryDetailedGet, any>({
      path: `/categories/${categoryId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Categories
   * @name CreateCategory
   * @summary Создание категории
   * @request POST:/categories/create
   * @secure
   * @response `200` `string` Идентификатор категории
   */
  createCategory = (query: CreateCategoryParams, data: CreateCategoryBody, params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/categories/create`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Categories
   * @name UpdateCategory
   * @summary Обновление категории
   * @request POST:/categories/{categoryId}/update
   * @secure
   * @response `200` `void` Success
   */
  updateCategory = (categoryId: string, data: UpdateCategoryBody, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/categories/${categoryId}/update`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Categories
   * @name DeleteCategory
   * @summary Удаление категории
   * @request POST:/categories/{categoryId}/delete
   * @secure
   * @response `200` `void` Success
   */
  deleteCategory = (categoryId: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/categories/${categoryId}/delete`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Categories
   * @name CloneProduct
   * @summary Клонирование изделия
   * @request POST:/categories/cloneProduct
   * @secure
   * @response `200` `string` Идентификатор изделия
   */
  cloneProduct = (query: CloneProductParams, data: CloneProductBody, params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/categories/cloneProduct`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Categories
   * @name ExportCategory
   * @summary Экспорт категории
   * @request POST:/categories/{categoryId}/export
   * @secure
   * @response `200` `File` Архив экспорта категории
   */
  exportCategory = (categoryId: string, data: ExportCategoryBody, params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/categories/${categoryId}/export`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Categories
   * @name ImportEmb
   * @summary Импорт категории формата .emb
   * @request POST:/categories/import
   * @secure
   * @response `200` `string` Идентификатор категории
   */
  importEmb = (data: ImportEmbPayload, params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/categories/import`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Categories
   * @name ImportCheck
   * @summary Проверка возможности импортировать категорию
   * @request POST:/categories/importCheck
   * @secure
   * @response `200` `void` Success
   */
  importCheck = (data: ImportCheckPayload, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/categories/importCheck`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags Categories
   * @name ImportEmbx
   * @summary Импорт категории формата .embx
   * @request POST:/categories/importX
   * @secure
   * @response `200` `string` Идентификатор категории
   */
  importEmbx = (data: ImportEmbxPayload, params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/categories/importX`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Categories
   * @name AddImportFile
   * @summary Загрузка импортируемых документов
   * @request POST:/categories/addImportFile
   * @secure
   * @response `200` `void` Success
   */
  addImportFile = (data: AddImportFilePayload, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/categories/addImportFile`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags Categories
   * @name GetSecurityList
   * @summary Получение списка настроек доступа
   * @request POST:/categories/getSecurity
   * @secure
   * @response `200` `TableModel1CategorySecurityGet` Список настроек доступа
   */
  getSecurityList = (data: SecurityFilter, params: RequestParams = {}) =>
    this.request<TableModel1CategorySecurityGet, any>({
      path: `/categories/getSecurity`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Categories
   * @name UpdateSecurityRule
   * @summary Метод изменения настроек доступа к категории
   * @request POST:/categories/updateSecurity
   * @secure
   * @response `200` `void` Success
   */
  updateSecurityRule = (data: UpdateSecurityRuleBody, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/categories/updateSecurity`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Categories
   * @name DeleteSecurityRule
   * @summary Метод удаления настроек доступа к категории
   * @request POST:/categories/deleteSecurity
   * @secure
   * @response `200` `void` Success
   */
  deleteSecurityRule = (data: DeleteSecurityRuleBody, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/categories/deleteSecurity`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Categories
   * @name SetDefaultCategory
   * @summary Метод назначения категории по умолчанию
   * @request POST:/categories/setDefCategory
   * @secure
   * @response `200` `void` Success
   */
  setDefaultCategory = (data: SetDefaultCategoryBody, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/categories/setDefCategory`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
